import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute';
import AdminDashboard from '../../pages/admin/AdminDashboard';
import AdminUsers from '../../pages/admin/AdminUsers';
import AdminTournaments from '../../pages/admin/AdminTournaments';
import AdminBlocks from '../../pages/admin/AdminBlocks';
import AdminCreateBlock from '../../pages/admin/AdminCreateBlock';
import AdminEditBlock from '../../pages/admin/AdminEditBlock';
import AdminPlayers from '../../pages/admin/AdminPlayers';
import AdminAnalytics from '../../pages/admin/AdminAnalytics';
import EditTournament from '../../pages/EditTournament';

const AdminRouter = () => {
  return (
    <Routes>
      <Route path="/" element={
        <PrivateRoute>
          <AdminDashboard />
        </PrivateRoute>
      } />
      <Route path="/users" element={
        <PrivateRoute>
          <AdminUsers />
        </PrivateRoute>
      } />
      <Route path="/tournaments" element={
        <PrivateRoute>
          <AdminTournaments />
        </PrivateRoute>
      } />
      <Route path="/players" element={
        <PrivateRoute>
          <AdminPlayers />
        </PrivateRoute>
      } />
      <Route path="/blocks" element={
        <PrivateRoute>
          <AdminBlocks />
        </PrivateRoute>
      } />
      <Route path="/blocks/create" element={
        <PrivateRoute>
          <AdminCreateBlock />
        </PrivateRoute>
      } />
      <Route path="/blocks/:id/edit" element={
        <PrivateRoute>
          <AdminEditBlock />
        </PrivateRoute>
      } />
      <Route path="/analytics" element={
        <PrivateRoute>
          <AdminAnalytics />
        </PrivateRoute>
      } />
      <Route path="/tournaments/:id/edit" element={
        <PrivateRoute>
          <EditTournament />
        </PrivateRoute>
      } />
    </Routes>
  );
};

export default AdminRouter;
